// A placeholder component. Will be extended by concrete input components in ./*/editable-inputs.
// Similar in logic to `SharedAddressListColumnComponent`
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IntersectionStatus,
} from '../../../../directives/general-intersection/from-intersection-observer';
import { FormGroup } from '@angular/forms';
import { EditLocationSection } from '../edit-location.component';
import { isFieldWithDataSource } from '../../data-source-utils';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { memoize } from '../../../../core/decorators/memoize';
import { EditLocationLocalStore } from '../edit-location-local-store.service';
import * as locationListSelectors from '../../location-list/state/location-list-selectors';
import { EditLocationTControl } from '../../../../models/locations-models/edit-location-form';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class SharedEditLocationSectionComponent {
  @Input() sectionName: EditLocationSection;

  constructor(protected store: Store, protected localStore: EditLocationLocalStore) {
  }

  /**
   * Update the intersection status in the local store.
   * @param $event Visibility (Intersection status = Visible | Invisible | Pending)
   */
  onVisibilityChanged($event: IntersectionStatus) {
    this.localStore.updateSectionVisibility({ section: this.sectionName, visibility: $event });
  }

  /**
   * Wrapper around the data source util
   * @param fieldId
   */
  @memoize()
  isFieldWithDataSource(fieldId: string): boolean {
    return isFieldWithDataSource(fieldId);
  }


  /**
   * Wrapper around the data source util
   * @param fieldId
   */
  @memoize()
  hasActiveConnection(fieldId: string): Observable<boolean> {
    return this.store.select(locationListSelectors.selectHasActiveConnection(fieldId));
  }

  /**
   * form grp getter
   */
  getFormGroup(): FormGroup<EditLocationTControl> {
    return this.localStore.formGroup;
  }
}
